import { Messages } from '../../../../codegen/Localize';
import { setOwner } from '../../../actions/spaces/SetOwnerAction';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { ICollectionInfo } from '../../Collections/ICollectionInfo';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { userCanManageAnyCollection } from './IEntityActionHelpers';
import { CompositeSessionInfoSelectors } from '../../../selectors/SessionInfoSelectors';

export const SetCollectionOwnerEntityAction: IEntityAction<ICollectionInfo, {}> = {
  name: EntityActionNames.SetOwner,
  translateName: Messages.changeOwner_action,
  isVisible: () => {
    return FeatureFlags.collectionsEnabled;
  },
  isClickable: (_availableActions: {}, targetItems: ICollectionInfo[], state: AppState) => {
    return !CompositeSessionInfoSelectors.isLimitedUserVisibilityEnforced(state) && userCanManageAnyCollection(state, targetItems);
  },
  createReduxAction: (targetItems: ICollectionInfo[]) => setOwner(targetItems)
};
